import { BaseEntity } from "./BaseEntity";

export default class Admin extends BaseEntity {

    constructor(id: number, public name: string, public email: string) {
        super(id);
    }

}